<template>
  <div class="main">
    <h2 class="title">Activiteiten</h2>
    <table class="new">
      <tr>
        <th width="140">Datum</th>
        <th width="140">IP-adres</th>
        <th>Activiteit</th>
      </tr>
      <tr
        v-for="(log, index) in logs"
        :key="index"
      >
        <td>{{ new Date(log.date).toLocaleString() }}</td>
        <td class="message">{{ log.ip }}</td>
        <td class="message">{{ log.type }}</td>
      </tr>
    </table>
    <pagerElement
      v-model="currentPage"
      :records="totalLogs"
      :resultsPerPage="maxPerPage"
    />
  </div>
</template>
<script>

export default {
  name: 'ProfileActivities',
  data() {
    return {
      logs: null,
      currentPage: 0,
      totalLogs: 0,
      maxPerPage: 10,
    };
  },
  created() {
    this.getLogs();
    this.$parent.hasStickyMenu = true;
  },
  watch: {
    currentPage() {
      this.getLogs();
    },
  },
  methods: {
    getLogs() {
      let filter = [];
      filter = filter.join(';');
      this.sdk.getLogs((response) => {
        if (response.status === 200) {
          this.logs = response.data.results;
          this.totalLogs = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
  },
};
</script>
